export default __webpack_public_path__ + "static/media/border-join-miter-17.61538d83.svg";